module.exports = __webpack_public_path__ + "img/target.a5de77dd.svg";